import { useEffect, useState } from 'react'
import { useAnnoncestore } from 'src/store/search'
import {
  Pagination,
  Card,
  Col,
  Button,
  Row,
  Spin,
  Tag,
  Select,
  Input,
  Space
} from 'antd'
import { PhotoProvider, PhotoView } from 'react-photo-view'
import { USDollar } from 'src/utils'
import { Preloader } from 'src/components/preloader'
import { useAuthStore } from 'src/store/auth'
import { API } from 'src/API'
import 'react-photo-view/dist/react-photo-view.css'
import { RemoveModal } from 'src/components/removeModal'
import { Link } from 'react-router-dom'
import { ArrowUpOutlined, ArrowDownOutlined } from '@ant-design/icons'
import { ActionModal } from 'src/components/ActionModal'
import { UpdateAnnonceModal } from 'src/components/UpdateAnnonceModal'
import { ViewProfileModal } from 'src/components/viewProfileModal'
import { useDebounce } from 'use-debounce'
import { SearchOutlined } from '@ant-design/icons'

export const Annonces = () => {
  const { searchData, isLoading, onSearch, searchPagination } = useAnnoncestore(
    (store) => store
  )

  const { setActiveKeyMainMenu } = useAuthStore((store) => store)

  const [sortBy, setSortBy] = useState('created_at')
  const [sortDirection, setSortDirection] = useState('asc')
  const [sortSuperDeal, setSortSuperDeal] = useState('all')
  const [search, setSearch] = useState('')

  const [value] = useDebounce(search, 500)

  const handleChange = (value) => {
    setSortBy(value)
  }

  const OPTIONS = [
    { value: 'updated_at', label: 'Updated At' },
    { value: 'created_at', label: 'Created At' },
    { value: 'price', label: 'Price' },
    { value: 'type', label: 'Type' },
    { value: 'status', label: 'Status' },
    { value: 'title', label: 'Title' },
    { value: 'description', label: 'Description' }
  ]

  const SUPER_DEAL_OPTIONS = [
    { value: 'all', label: 'All' },
    { value: 'active', label: 'Active' },
    { value: 'disabled', label: 'Disabled' }
  ]

  const handleDirection = () => {
    const newDirection = sortDirection === 'asc' ? 'desc' : 'asc'

    setSortDirection(newDirection)
  }

  useEffect(() => {
    onSearch(1, sortBy, sortDirection, sortSuperDeal, search)
  }, [sortBy, sortDirection, sortSuperDeal, value])

  useEffect(() => {
    setActiveKeyMainMenu('mainMenu1')
  }, [])

  const getType = (el) => {
    switch (el) {
      case 'buying':
        return 'Ask'
      case 'selling':
        return 'Sell'
      default:
        return el || '-'
    }
  }

  return (
    <div>
      <h1>Annonces</h1>
      <Space wrap>
        <div>
          <p style={{ paddingBottom: 5 }}>Sort By</p>
          <Select
            style={{ width: 200 }}
            value={sortBy}
            onChange={handleChange}
            options={OPTIONS}
          />
        </div>
        <div>
          <p style={{ paddingBottom: 5 }}>Super deal</p>
          <Select
            style={{ width: 200 }}
            value={sortSuperDeal}
            onChange={setSortSuperDeal}
            options={SUPER_DEAL_OPTIONS}
          />
        </div>
        <div>
          <p style={{ paddingBottom: 5 }}>Search</p>
          <Input
            placeholder='Search...'
            onChange={(e) => setSearch(e.target.value)}
            value={search}
            prefix={<SearchOutlined />}
          />
        </div>
        <div>
          <p
            style={{ paddingBottom: 5, cursor: 'pointer' }}
            onClick={handleDirection}
          >
            Sort Direction
          </p>
          {sortDirection === 'asc' ? (
            <ArrowUpOutlined onClick={handleDirection} />
          ) : (
            <ArrowDownOutlined onClick={handleDirection} />
          )}
        </div>
      </Space>
      <div style={{ position: 'relative', padding: '20px 0' }}>
        {isLoading ? <Preloader /> : null}
        {searchData
          ? searchData.map((photo) => (
              <Card key={photo?.id} style={{ margin: '10px 0' }}>
                <Row>
                  <Col
                    xs={24}
                    md={6}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                  >
                    <div>
                      <p style={{ paddingBottom: 5 }}>
                        ID: <Tag color='red'>{photo?.id || '-'}</Tag>
                      </p>
                      <p style={{ paddingBottom: 5 }}>
                        Created at:{' '}
                        <Tag color='green'>
                          {photo?.readable_created_at || '-'}
                        </Tag>
                      </p>
                      <p style={{ paddingBottom: 5 }}>
                        Price:{' '}
                        <Tag color='blue'>
                          {photo?.price ? USDollar.format(photo?.price) : '-'}
                        </Tag>
                      </p>
                      <p style={{ paddingBottom: 5 }}>
                        Updated at:{' '}
                        <Tag color='cyan'>
                          {photo?.readable_updated_at || '-'}
                        </Tag>
                      </p>
                      <ViewProfileModal data={photo?.owner?.data} />
                      <div style={{ paddingTop: 10 }}>
                        <ActionModal
                          refresh={() =>
                            onSearch(
                              1,
                              sortBy,
                              sortDirection,
                              sortSuperDeal,
                              search
                            )
                          }
                          endpoint={API.COMMON.annoncesEndpoint}
                          title={'Update super deal?'}
                          text={`Are you sure to ${
                            photo?.super_deal ? 'disable' : 'enable'
                          } super-deal${
                            photo?.title ? ` for a ${photo?.title}` : ''
                          }?`}
                          id={photo?.id}
                          reqData={{
                            super_deal: !photo?.super_deal
                          }}
                          type='put'
                          ntftTitle='Annonces'
                          btnText={`${
                            photo?.super_deal ? 'Disable' : 'Enable'
                          } super-deal`}
                        />
                      </div>
                      <div style={{ paddingTop: 10 }}>
                        <UpdateAnnonceModal
                          refresh={() =>
                            onSearch(
                              1,
                              sortBy,
                              sortDirection,
                              sortSuperDeal,
                              search
                            )
                          }
                          endpoint={API.COMMON.annoncesEndpoint}
                          modalTitle={'Update annonce?'}
                          modalText={`Are you sure to update${
                            photo?.title ? ` ${photo?.title}` : ''
                          }?`}
                          id={photo?.id}
                          reqData={photo}
                          reqType='put'
                          ntftTitle='Update annonce'
                          btnText={`Update`}
                        />
                      </div>
                      {/* <Link to={`${photo?.id}`}>
                        <Button style={{ marginTop: 10 }} type='primary'>
                          Details
                        </Button>
                      </Link> */}
                    </div>
                  </Col>
                  <Col
                    xs={24}
                    md={6}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                  >
                    <div>
                      <p style={{ paddingBottom: 5 }}>
                        Status:{' '}
                        <Tag
                          color={`${
                            photo?.status === 'active' ? 'lime' : 'red'
                          }`}
                        >
                          {photo?.status || '-'}
                        </Tag>
                      </p>
                      <p style={{ paddingBottom: 5 }}>
                        Type: <Tag color='green'>{getType(photo?.type)}</Tag>
                      </p>
                      <p style={{ paddingBottom: 5 }}>
                        Category:{' '}
                        <Tag color='blue'>{photo?.category?.title || '-'}</Tag>
                      </p>
                      <p style={{ paddingBottom: 5 }}>
                        Category EN:{' '}
                        <Tag color='blue'>
                          {photo?.category?.title_en || '-'}
                        </Tag>
                      </p>
                      <p style={{ paddingBottom: 5 }}>
                        Super-deal:{' '}
                        <Tag color='pink'>
                          {photo?.super_deal ? 'active' : 'disabled'}
                        </Tag>
                      </p>
                      <RemoveModal
                        refresh={() =>
                          onSearch(
                            1,
                            sortBy,
                            sortDirection,
                            sortSuperDeal,
                            search
                          )
                        }
                        endpoint={API.COMMON.annoncesEndpoint}
                        title={'Delete annonce?'}
                        text={`Are you sure to delete the ${
                          photo?.title?.length > 30
                            ? `${photo?.title.slice(30)}...`
                            : photo?.title
                        } annonce?`}
                        id={photo?.id}
                      />
                    </div>
                  </Col>
                  <Col
                    xs={24}
                    md={6}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexDirection: 'column'
                    }}
                  >
                    <p>Photo: </p>
                    {photo?.photos?.data?.[0] ? (
                      <PhotoProvider>
                        <div>
                          {photo?.photos?.data.map((item) => (
                            <PhotoView key={item?.id} src={item?.thumb_l}>
                              <img
                                style={{ margin: 2, maxWidth: 100, maxHeight: 100 }}
                                src={item.thumb_m}
                                alt={item?.id}
                              />
                            </PhotoView>
                          ))}
                        </div>
                      </PhotoProvider>
                    ) : (
                      '-'
                    )}
                  </Col>
                  <Col
                    xs={24}
                    md={6}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                  >
                    <div>
                      <p>Title:</p>
                      <p style={{ paddingBottom: 5 }}>
                        <b>{photo?.title || '-'}</b>
                      </p>
                      <p>Description:</p>
                      <p>
                        <b>{photo?.description || '-'}</b>
                      </p>
                    </div>
                  </Col>
                </Row>
              </Card>
            ))
          : null}
      </div>
      {searchPagination ? (
        <Pagination
          defaultCurrent={1}
          current={searchPagination?.current_page}
          total={searchPagination?.total}
          pageSize={searchPagination?.per_page}
          onChange={(newPage) =>
            onSearch(newPage, sortBy, sortDirection, sortSuperDeal, search)
          }
          showTotal={(total, range) => `${range[0]}-${range[1]} of ${total}`}
        />
      ) : null}
    </div>
  )
}
